import { Extension } from "@tiptap/core";
import { TextSelection } from "@tiptap/pm/state";

export const SmartSelectAll = Extension.create({
  name: "smartSelectAll",

  addKeyboardShortcuts() {
    return {
      "Mod-a": ({ editor }) => {
        const { state, view } = editor;
        const { selection, doc } = state;
        const { $from, from, to } = selection;

        const blockDepth = $from.depth;
        if (blockDepth === 0) return false;

        const blockStart = $from.start(blockDepth);
        const blockEnd = $from.end(blockDepth);

        const isBlockAlreadyCovered = from <= blockStart && to >= blockEnd;
        if (isBlockAlreadyCovered) return false;

        const tr = state.tr.setSelection(
          TextSelection.create(doc, blockStart, blockEnd),
        );
        view.dispatch(tr);
        return true;
      },
    };
  },
});
